export default "<app-product-depth-level *ngIf=\"item\" [item]=\"item\" [params]=\"params\" [isps]=\"isps\"></app-product-depth-level>"